const SCREEN_RESIZE = "ui/SCREEN_RESIZE";

const initialState = {
  width: false,
  height: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SCREEN_RESIZE:
      return {
        width: action.width,
        height: action.height,
      };
    default:
      return state;
  }
}

export function screenResize({ width, height }) {
  return {
    type: SCREEN_RESIZE,
    width,
    height,
  };
}
